const links = document.querySelectorAll(".blog-filters__button");

function getTotalNavHeight() {
  let navHeight = document.querySelector("#shopify-section-header").clientHeight;
  let faqNavHeight = document.querySelector(".blog-filters").clientHeight;
  let totalNavHeight = navHeight + faqNavHeight;

  return [navHeight, totalNavHeight];
}

function setStickyPosition() {
  let totalNavHeight = getTotalNavHeight();
  document.querySelector(".blog-filters").style.top = `${
    totalNavHeight[0] - 2
  }px`;
}

let totalNavHeight = getTotalNavHeight();

window.addEventListener("resize", (event) => setStickyPosition());
window.addEventListener("DOMContentLoaded", (event) => setStickyPosition());